import { RightsAndRolesPage } from "@/components/admin/rights/rights-and-roles-page.tsx";
import { m } from "@/paraglide/messages.js";
import { capabilitiesQueryOptions } from "@/services/capabilities-service.ts";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { rightsTab } from "@/components/admin/rights/rights-tabs.ts";
import { pageTitle } from "@/utils/page-title.ts";
import { RoutePending } from "@/components/custom/route-pending.tsx";

/**
 * "Rights & Roles" in the settings shell. The `isAdmin` guard comes from the
 * `/settings/org` subtree route, so none is repeated here — the same idiom as
 * every other page under it.
 *
 * The `?tab=&provider=` deep link is carried over from the page's previous home at
 * /dashboard/admin/rights (which is now a redirect shim forwarding both params),
 * so the cross-link from the integrations access section keeps working.
 */
export const Route = createFileRoute("/_authenticated/settings/org/rights")({
	component: RightsAndRolesPage,
	pendingComponent: RoutePending,
	// A capability matrix and two grids, not a form: the reading column squeezes
	// them into a horizontal scroller nobody finds.
	staticData: { settingsWidth: "wide" },
	validateSearch: z.object({
		// .catch(): a hand-tampered ?tab=xyz degrades to the default tab instead
		// of the route error boundary (the api-keys.tsx precedent).
		tab: rightsTab.optional().catch(undefined),
		/** Deep link for the "Tool access" tab: preselect this integration provider. */
		provider: z.string().optional(),
	}),
	loader: async ({ context: { queryClient } }) => {
		queryClient.prefetchQuery(capabilitiesQueryOptions());
	},
	head: () => ({
		meta: [{ title: pageTitle(m.admin_settings_rights_tab()) }],
	}),
});
